var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.14062C6.61522 3.14062 2.25 7.50585 2.25 12.8906C2.25 18.2754 6.61522 22.6406 12 22.6406C17.3848 22.6406 21.75 18.2754 21.75 12.8906C21.75 7.50585 17.3848 3.14062 12 3.14062ZM10.2803 10.1103C9.98744 9.8174 9.51256 9.8174 9.21967 10.1103C8.92678 10.4032 8.92678 10.8781 9.21967 11.171L10.9393 12.8906L9.21967 14.6103C8.92678 14.9032 8.92678 15.3781 9.21967 15.671C9.51256 15.9638 9.98744 15.9638 10.2803 15.671L12 13.9513L13.7197 15.671C14.0126 15.9638 14.4874 15.9638 14.7803 15.671C15.0732 15.3781 15.0732 14.9032 14.7803 14.6103L13.0607 12.8906L14.7803 11.171C15.0732 10.8781 15.0732 10.4032 14.7803 10.1103C14.4874 9.8174 14.0126 9.8174 13.7197 10.1103L12 11.83L10.2803 10.1103Z",
    fill: "#EA4748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.cb89d7c39580717385cad9145024851f.svg";
export { ForwardRef as ReactComponent };